import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  DialogTitle,
  Autocomplete,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useFormik } from "formik";
import {
  useCreateCustomerMutation,
  useCreateWorkOrderMutation,
  useConvertToInvoiceMutation,
  useGetAllSearchCompanyQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetLastWorkOrderIdQuery,
  useGetPriceHistoryQuery,
  useGetProductQuery,
  useGetTaxQuery,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import { useStyles } from "../../../theme/appStyles";
import { useNavigate } from "react-router";
import { fmtCustomerName } from '../../../Core/utils/nameUtils';
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import {
  ICompanyDetails,
  ICustomer,
  IPriceHistoryPayload,
  IProductPopUP,
  ITaxes,
} from "../../../Api/Interface/api.interface";
import {
  validateEmail,
  validatePhoneNumber,
} from "../../../Components/Validation/validationUtils";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { toDate } from "date-fns";
import dayjs, { Dayjs } from "dayjs";
import { normalizeDateTimeFields } from "../../../Core/utils/dateTime";
import {
  ProductType,
  TransferType,
  WorkOrderStatus,
} from "../../../Core/Enum/enum";
import AddIcon from "@mui/icons-material/Add";
import { FaTrash } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import NewCompanyPopUp from "../../CompanyInfo/Components/NewCompanyPopUp";
import NewCustomerPopUp from "../../Customer/Components/NewPopUpCustomer";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { uploadImage } from "../../../Components/UploadFile/upload";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import { useParams } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import placeholderImage from '../../../Images/fav.png';
import { City } from "country-state-city";
import { createFilterOptions } from '@mui/material/Autocomplete';
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const generateWorkOrderNumber = (workOrderId: number) => {
  const date = new Date();
  const year = date.getFullYear().toString().slice(2);
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `WO${year}${month}${day}-${workOrderId.toString().padStart(2, "0")}`;
};

interface IProduct {
  productName: string;
  productDescription: string;
  productImg: String | null;
  numberOfPassengers: number | null;
  busCount: number | null
  transferType: string;
  transferTypeFrom: string;
  transferTypeTo: string;
  transferTypeDescription: string;
  departureDateTime: Dayjs | null;
  returnDateTime: Dayjs | null;
  departureAddress: string;
  destinationAddress: string;
  multiDestination: string;
  quantity: number | null;
  price: number | null;
  tax: number;
  taxAmount: number;
  total: number;
  taxId: number | null;
  unitPriceWithDiscount: number | null;
  unitTotalWithDiscount: number;
  productType: string;
  productLongDescription: string;
  productShortDescription: string;
}

interface IDiscount {
  value: number | null;
  type: "fixed" | "percent";
  description: string;
}

interface IProduct {
  productName: string;
  transferTypeTo: string;
  transferTypeFrom: string;
}

const quoteInfoLabel = {
  fontSize: 10,
  fontWeight: 600,
  color: "#94a3b8",
  textTransform: "uppercase" as const,
  letterSpacing: 0.6,
  mb: 0.25,
};

const quoteInfoValue = {
  fontSize: 13,
  fontWeight: 500,
  color: "#1e293b",
  lineHeight: 1.5,
};

const QuoteInfoBlock = ({ label, value }: { label: string; value?: string | null }) => (
  <Box>
    <Typography sx={quoteInfoLabel}>{label}</Typography>
    <Typography sx={quoteInfoValue}>{value || "—"}</Typography>
  </Box>
);

const Index: React.FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const [newTax, { isLoading }] = useCreateWorkOrderMutation();
  const { showErrorMessage, showMessage } = useNotifier();
  const { id: customerId } = useParams<{ id: string }>();

  // const [searchQuery, setSearchQuerffy] = useState<string>("");
  // const [currentSearchQuery, setCurrentSearchQuery] = useState<string>("");
  // const debouncedSearchQuery = useDebounce(searchQuery, 300);
  // const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const [searchQueryCustomer, setSearchQueryCustomer] = useState<string>("");
  const [currentSearchQueryCustomer, setCurrentSearchQueryCustomer] =
    useState<string>("");
  const debouncedSearchQueryCustomer = useDebounce(searchQueryCustomer, 300);
  const [showDropdownCustomer, setShowDropdownCustomer] =
    useState<boolean>(false);

  const [searchQueryProduct, setSearchQueryProduct] = useState<string>("");
  const [currentSearchQueryProduct, setCurrentSearchQueryProduct] =
    useState<string>("");
  const debouncedSearchQueryProduct = useDebounce(searchQueryProduct, 300);
  const [showDropdownProductIndex, setShowDropdownProductIndex] = useState<
    number | null
  >(null);

  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [isImageUploading, setIsImageUploading] = useState(false);

  const [selectedDefultCompanyId, setSelectedDefultCompanyId] =
    useState<string>("");

  const [averagePrice, setAveragePrice] = useState<number | null>(null);
  const [nextPrice, setNextPrice] = useState<number | null>(null);
  const [quoteWorkOrderNo, setQuoteWorkOrderNo] = useState<String | null>(null);
  const [updated_at, setUpdated_at] = useState<Date | null>(null);
  const [priceId, setPriceId] = useState<number | null>(null);
  const [open, setOpen] = useState(false);
  const [openD, setOpenD] = useState(false);
  const [id, setId] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  const [currentPriceQueryParams, setCurrentPriceQueryParams] =
    useState<IPriceHistoryPayload | null>(null);

  const [currentIndex, setCurrentIndex] = useState<number | null>(null);
  const [originalProduct, setOriginalProduct] = useState<IProduct | null>(null); 
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [canadianCities, setCanadianCities] = useState<string[]>([]); 
  const [busCount, setBusCount] = useState<number | null>(null);
  const [errors, setErrors] = useState<{ departureDateTime?: string; returnDateTime?: string; productName?: string; numberOfPassengers?: string; busCount?: string; transferType?: string; price?: string }>({});
  const [taxAmount, setTaxAmount] = useState<number>(0);

  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      const maxSize = 2048 * 1024; // 2 MB

      if (!validTypes.includes(file.type)) {
        showErrorMessage("The file must be an image (jpeg, png, jpg, gif).");
        return;
      } else if (file.size > maxSize) {
        showErrorMessage("The file must be smaller than 2 MB.");
        return;
      } else {
        try {
          setIsImageUploading(true);
          const uploadedImageUrl = await uploadImage(file);
          const updatedRows = [...productRows];
          updatedRows[index].productImg = uploadedImageUrl;
          setProductRows(updatedRows);
          setIsImageUploading(false);
        } catch (error) {
          showErrorMessage("Failed to upload the image.");
          setIsImageUploading(false);
        }
      }
    }
  };

  const { data: taxData, isLoading: taxLoading } = useGetTaxQuery({
    searchText: "",
  });

  const taxList = useMemo(() => {
    return taxData?.data as ITaxes[];
  }, [taxData?.data]);

  // const defaultTax = useMemo(() => {
  //   const foundDefaultTax = taxList.find((tax) => tax.isDefault === true);
  //   return foundDefaultTax ? foundDefaultTax : taxList[0] || null;
  // }, [taxList]);

  const [productRows, setProductRows] = useState<IProduct[]>([]);

  const [discounts, setDiscounts] = useState<IDiscount[]>([]);

  // const [discounts, setDiscounts] = useState<IDiscount[]>([
  //   { value: null, description: "" },
  // ]);
  const [discountValue, setDiscountValue] = useState<number>(0);
  const [discountDescription, setDiscountDescription] = useState<string>("");
  const [subTotal, setSubTotal] = useState<number>(0);
  const [totalDiscount, setTotalDiscount] = useState<number>(0);
  const [grandTotal, setGrandTotal] = useState<number>(0);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [unitPrice, setUnitPrice] = useState<number>(0);
  const [grandTotalEithDiscount, setGrandTotalWithDiscount] =
    useState<number>(0);

  const [selectedCompanyLogo, setSelectedCompanyLogo] = useState<string | null>(
    null
  );
  const [openCompany, setOpenCompany] = useState(false);
  const [poNumber, setPoNumber] = useState("");
  const [discountType, setDiscountType] = useState<"fixed" | "percent">("fixed");
  const [selectedCustomer, setSelectedCustomer] = useState<ICustomer | null>(null);
  const [showCustomerError, setShowCustomerError] = useState(false);
  const [openCustomer, setOpenCustomer] = useState(false);
  const {
    data: companyData,
    isLoading: companyIsLoading,
    isError,
    refetch,
  } = useGetCompanyQuery({
    searchText: "",
    id: "",
  });

  const { data: workOrderLastData, isLoading: workOrderIsLoading } =
    useGetLastWorkOrderIdQuery();

  const {
    data: customerData,
    isLoading: customerIsLoading,
    isError: cutomerError,
    refetch: cutomerRefetch,
  } = useGetCustomerQuery({
    searchText: currentSearchQueryCustomer,
    id: "",
  });

  const {
    data: productData,
    isLoading: productIsLoading,
    refetch: productRefetch,
  } = useGetProductQuery({
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    searchText: currentSearchQueryProduct,
    createdDate: null,
    id: null,
  });

  const initialParams: IPriceHistoryPayload = {
    productName: "",
    transferTypeFrom: "",
    transferTypeTo: "",
  };

  const {
    data: priceHistoryData,
    isLoading: priceHistoryIsLoading,
    isError: priceHistoryError,
  } = useGetPriceHistoryQuery(
    currentPriceQueryParams ?? initialParams,
    {
      skip: !currentPriceQueryParams,
    }
  );

  // const {
  //   data: updateData,
  //   isLoading: updateIsLoading,
  //   isError: updateError,
  // } = useUpdateInvoiceStatusQuery(
  //   {
  //     mainStatus: "2",
  //     id: id, // Use the ID for updating the invoice status
  //   },
  //   { skip: !id }
  // ); // Skip query until ID is available


  const [convertToInvoice] = useConvertToInvoiceMutation();

  const companyList: ICompanyDetails[] = Array.isArray(companyData?.data)
    ? (companyData?.data as ICompanyDetails[])
    : [];

  const rawData = workOrderLastData?.data;
  const workOrderId =
    typeof rawData === "number"
      ? rawData
      : parseInt(rawData as string, 10) || 0;

  useEffect(() => {
    if (
      priceHistoryData &&
      Array.isArray(priceHistoryData.data) &&
      priceHistoryData.data.length > 0
    ) {
      setAveragePrice(priceHistoryData.data[0]?.averagePrice || null);
      setNextPrice(priceHistoryData.data[0]?.price || null);
      setQuoteWorkOrderNo(priceHistoryData.data[0]?.quoteWorkOrderNo || null);
      setUpdated_at(priceHistoryData.data[0]?.updated_at || null);
      setPriceId(priceHistoryData.data[0]?.workOrderId || null);
      setBusCount(priceHistoryData.data[0]?.busCount || null);
    } else {
      setAveragePrice(null);
      setNextPrice(null);
      setQuoteWorkOrderNo(null);
      setUpdated_at(null);
      setPriceId(null);
      setBusCount(null); 
    }
  }, [priceHistoryData]);

  const generatedWorkOrderNo = generateWorkOrderNumber(workOrderId);

  // useEffect(() => {
  //   if (debouncedSearchQuery.length >= 0 || debouncedSearchQuery === "") {
  //     setCurrentSearchQuery(debouncedSearchQuery);
  //     refetch();
  //   }
  // }, [debouncedSearchQuery, refetch]);

  // const handleFocusOrClick = () => {
  //   setShowDropdown(true);
  //   if (currentSearchQuery === "") {
  //     refetch();
  //   }
  // };

  const handleFocusOrClickCustomer = () => {
    setShowDropdownCustomer(true);
    if (currentSearchQueryCustomer === "") {
      refetch();
    }
  };

   useEffect(() => {
        // Fetch all cities in Canada (country code "CA")
        const cities = City.getCitiesOfCountry("CA");
        if (cities) {
          setCanadianCities(Array.from(new Set(cities.map((city) => city.name))).sort());
        }
      }, []);
  

  useEffect(() => {
    if (selectedCustomer) return; // customer already picked — no need to refetch
    if (
      debouncedSearchQueryCustomer.length >= 2 ||
      debouncedSearchQueryCustomer === ""
    ) {
      setCurrentSearchQueryCustomer(debouncedSearchQueryCustomer);
      cutomerRefetch();
    }
  }, [debouncedSearchQueryCustomer, cutomerRefetch, selectedCustomer]);

  useEffect(() => {
    if (
      debouncedSearchQueryProduct.length >= 2 ||
      debouncedSearchQueryProduct === ""
    ) {
      setCurrentSearchQueryProduct(debouncedSearchQueryProduct);
      productRefetch();
    }
  }, [debouncedSearchQueryProduct, productRefetch]);

  // useEffect(() => {
  //   const totalSubTotal = productRows.reduce((acc, row) => acc + row.total, 0);
  //   setSubTotal(totalSubTotal);

  //   const calculatedTotalDiscount = discounts.reduce(
  //     (acc, discount) => acc + (discount.value),
  //     0
  //   );
  //   setTotalDiscount(calculatedTotalDiscount);

  //   const totalGrandTotal = totalSubTotal - calculatedTotalDiscount;
  //   setGrandTotal(totalGrandTotal);
  // }, [productRows, discounts]);

  useEffect(() => {
     if (productRows.length > 0) {
       const totalSubTotal = productRows.reduce(
         (acc, row) => acc + row.total,
         0
       );
       setSubTotal(totalSubTotal);
 
       const calculatedTotalDiscount = discounts.reduce(
         (acc, discount) => acc + (discount.value ?? 0),
         0
       );
       setTotalDiscount(calculatedTotalDiscount);
 
       if (totalSubTotal > 0) {
         const unitPriceDiscount = totalDiscount / totalSubTotal;
         setUnitPrice(unitPriceDiscount);
 
         const updatedRows = productRows.map((row) => {
           const price = row.price ?? 0;
           const quantity = row.quantity ?? 0;
           const tax = row.tax ?? 0;
 
           const priceWithDiscount = price * (1 - unitPriceDiscount);
           const unitProductPriceWithDiscountAndTax =
             priceWithDiscount * (1 + tax / 100);
           const totalWithDiscountAndTax =
             priceWithDiscount * quantity * (1 + tax / 100);
             const taxAmountWithDiscount = priceWithDiscount * (tax / 100);
 
           return {
             ...row,
             unitPriceWithDiscount: unitProductPriceWithDiscountAndTax,
             unitTotalWithDiscount: totalWithDiscountAndTax,
             taxAmount: taxAmountWithDiscount, // Updating taxAmount after discount
           };
         });
 
         setProductRows((prevRows) => {
           // Only update the state if rows have actually changed
           if (JSON.stringify(prevRows) !== JSON.stringify(updatedRows)) {
             return updatedRows;
           }
           return prevRows;
         });
 
         const totalSubTotalWithDiscount = updatedRows.reduce(
           (acc, row) => acc + row.unitTotalWithDiscount,
           0
         );
         setGrandTotalWithDiscount(totalSubTotalWithDiscount);
       }
     }
   }, [productRows, discounts, totalDiscount]);
  
  const productList: IProductPopUP[] = Array.isArray(productData?.data)
    ? (productData?.data as IProductPopUP[])
    : [];

  const customerList: ICustomer[] = Array.isArray(customerData?.data)
    ? (customerData?.data as ICustomer[])
    : [];

  const today = dayjs();

  const handleProductSelect = (product: IProductPopUP, index: number) => {
    const updatedRows = [...productRows];
    updatedRows[index].productName = product.productName;
    updatedRows[index].productImg = product.productImg || "";

    setProductRows(updatedRows);
    setShowDropdownProductIndex(null);
    updatePriceQueryParams(updatedRows[index]);
  };

  const handleAddRow = () => {
    setEditIndex(null);
    setPopupOpen(true);
    
    setProductRows((prev) => [
      ...prev,
      {
        productName: "",
        productDescription: "",
        productImg: "",
        numberOfPassengers: null,
        busCount: null,
        transferType: TransferType.OneWayTransfer,
        transferTypeFrom: "",
        transferTypeTo: "",
        transferTypeDescription: "",
        departureDateTime: null,
        returnDateTime: null,
        departureAddress: "",
        destinationAddress: "",
        multiDestination: "",
        quantity: 1,
        price: null,
        tax: 0,
        taxAmount: 0,
        total: 0,
        taxId: 1,
        unitPriceWithDiscount: null,
        unitTotalWithDiscount: 0,
        productType: ProductType.Bus,
        productLongDescription: "",
        productShortDescription: "",
      },
    ]);
    setSearchQueryProduct("");
  };

  const handlePriceChange = (index: number, newPrice: number) => {
    const updatedRows = [...productRows];
    const product = updatedRows[index];
    product.price = newPrice;
  
    // Recalculate the tax amount whenever the price changes
    const newTaxAmount = newPrice * (product.tax / 100);
    product.taxAmount = newTaxAmount;

    const newTotal = newPrice * (product.quantity || 1) + newTaxAmount;
    product.total = newTotal;

    product.unitTotalWithDiscount = newTotal;
  
    setProductRows(updatedRows);
   // console.log(updatedRows)
  };

 const handleSaveProduct = () => {
    const currentRow = productRows[editIndex !== null ? editIndex : productRows.length - 1];
    let newErrors: { departureDateTime?: string; returnDateTime?: string; productName?: string; numberOfPassengers?: string; busCount?: string; transferType?: string; price?: string } = {};

    // Required fields
    if (!currentRow?.productName || String(currentRow.productName).trim() === "") {
      newErrors.productName = "Bus / Service is required";
    }
    if (!currentRow?.numberOfPassengers || Number(currentRow.numberOfPassengers) <= 0) {
      newErrors.numberOfPassengers = "Passengers is required";
    }
    if (!currentRow?.busCount || Number(currentRow.busCount) <= 0) {
      newErrors.busCount = "Buses (Qty) is required";
    }
    if (!currentRow?.transferType || String(currentRow.transferType).trim() === "") {
      newErrors.transferType = "Transfer Type is required";
    }
    if (currentRow?.price === undefined || currentRow?.price === null || Number(currentRow.price) <= 0) {
      newErrors.price = "Trip Price is required";
    }

    // Validate Departure Date & Time (Required)
    if (!currentRow?.departureDateTime) {
      newErrors.departureDateTime = "Departure Date & Time is required";
    }
  
    // Validate Return Date & Time if Transfer Type is NOT One-Way
    if (currentRow?.transferType !== TransferType.OneWayTransfer && !currentRow?.returnDateTime) {
      newErrors.returnDateTime = "Return Date & Time is required";
    }
  
    // If there are errors, update the state and stop submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
  
    // Clear errors if all validations pass
    setErrors({});
  
    if (editIndex !== null) {
      // Edit existing row
      const updatedRows = [...productRows];
      updatedRows[editIndex] = currentRow;
      setProductRows(updatedRows);
    } else {
      // Add new product
      setProductRows([...productRows]);
    }
  
    setPopupOpen(false);
  };

  const handleCancel = () => {
    if (editIndex !== null && originalProduct) {
      // Log the original product row before canceling
      console.log("Reverting to the original product row:", originalProduct);
  
      // Revert to the original product data (before editing)
      setProductRows(prevRows => {
        const updatedRows = [...prevRows];
        updatedRows[editIndex] = originalProduct; // Restore the original row
        return updatedRows;
      });
  
    
      setEditIndex(null);    // Clear edit index
      setOriginalProduct(null);  // Clear original product data after canceling
    } else {
      // If no row is being edited, just close the popup and remove the last empty row if necessary
      const lastRow = productRows[productRows.length - 1];
      if (
        !lastRow?.productName ||
        !lastRow?.productDescription ||
        !lastRow?.price ||
        (lastRow?.tax && lastRow?.tax <= 0)
      ) {
        console.log("Removing last row because it's empty or invalid");
        setProductRows(productRows.slice(0, productRows.length - 1));
      }
    }
    setPopupOpen(false);  // Close the popup
  };
  
  // const handleFieldChange = <K extends keyof IProduct>(
  //   index: number,
  //   field: K,
  //   value: IProduct[K]
  // ) => {
  //   const updatedRows = [...productRows];
  //   updatedRows[index][field] = value;

  //   updatedRows[index].total =
  //     updatedRows[index].price *
  //     updatedRows[index].quantity *
  //     (1 + updatedRows[index].tax / 100);

  //   setProductRows(updatedRows);
  // };

  // const handleFieldChange = <K extends keyof IProduct>(
  //   index: number,
  //   field: K,
  //   value: IProduct[K]
  // ) => {
  //   const updatedRows = [...productRows];
  //   updatedRows[index][field] = value;

  //   const price = updatedRows[index].price ?? 0;
  //   const quantity = updatedRows[index].quantity ?? 0;
  //   const tax = updatedRows[index].tax ?? 0;

  //   updatedRows[index].total = price * quantity * (1 + tax / 100);

  //   setProductRows(updatedRows);
  // };

  const handleFieldChange = <K extends keyof IProduct>(
    index: number,
    field: K,
    value: IProduct[K]
  ) => {
    const updatedRows = [...productRows];
    updatedRows[index][field] = value;

    const price = updatedRows[index].price ?? 0;
    const quantity = updatedRows[index].quantity ?? 0;
    const tax = updatedRows[index].tax ?? 0;

    updatedRows[index].total = price * quantity;

    const totalSubTotal = updatedRows.reduce((acc, row) => acc + row.total, 0);

    const totalDiscountValue = discounts.reduce(
      (acc, discount) => acc + (discount.value ?? 0),
      0
    );

    const unitPriceDiscount = totalDiscountValue / totalSubTotal;

    const priceWithDiscount = price * (1 - unitPriceDiscount);

    const unitProductPriceWithDiscountAndTax =
      priceWithDiscount * (1 + tax / 100);

    const totalWithDiscountAndTax =
      priceWithDiscount * quantity * (1 + tax / 100);

    updatedRows[index].unitPriceWithDiscount =
      unitProductPriceWithDiscountAndTax;
    updatedRows[index].unitTotalWithDiscount = totalWithDiscountAndTax;

    setProductRows(updatedRows);

    const priceAffectingFields = ["productName", "transferTypeFrom", "transferTypeTo"] as const;
    if (
      (priceAffectingFields as readonly string[]).includes(field as string) &&
      updatedRows[index].productName &&
      updatedRows[index].transferTypeFrom &&
      updatedRows[index].transferTypeTo
    ) {
      updatePriceQueryParams(updatedRows[index]);
      setCurrentIndex(index);
    }
  };



  const updatePriceQueryParams = (row: IProduct) => {
    const { productName, transferTypeFrom, transferTypeTo } = row;

    if (productName && transferTypeFrom && transferTypeTo) {
      setCurrentPriceQueryParams({ productName, transferTypeFrom, transferTypeTo });
      // RTK Query auto-fetches when params change — no explicit refetch needed
    }
  };

  useEffect(() => {
  // Calculate total subtotal
  const totalSubTotal = productRows.reduce((acc, row) => acc + (row.total || 0), 0);
  setSubTotal(totalSubTotal);

  // Calculate total discount
  const calculatedTotalDiscount = discounts.reduce(
    (acc, discount) => acc + (discount.value ?? 0),
    0
  );
  setTotalDiscount(calculatedTotalDiscount);

  // Calculate grand total (subtotal - discount)
  const totalGrandTotal = totalSubTotal - calculatedTotalDiscount;
  setGrandTotal(totalGrandTotal);

  // Calculate unit price
  const unitPrice = totalSubTotal > 0 ? calculatedTotalDiscount / totalSubTotal : 0;
  setUnitPrice(unitPrice);


 const calculatedHst = productRows.reduce((acc, row) => {
   return acc + (row.taxAmount ?? 0);
}, 0);
    setTaxAmount(calculatedHst);

  // Calculate grand total with discounts
  const totalSubTotalWithDiscount = productRows.reduce(
    (acc, row) => acc + (row.unitTotalWithDiscount || 0),
    0
  );
  setGrandTotalWithDiscount(totalSubTotalWithDiscount);
}, [productRows, discounts]);



  const handleProductNameChange = (index: number, value: string) => {
    setSearchQueryProduct(value);
    handleFieldChange(index, "productName", value);
  };

  const handleDeleteRow = (index: number) => {
   // const updatedRows = productRows.filter((_, i) => i !== index);
    const updatedRows = [...productRows];
    updatedRows.splice(index, 1);
    setProductRows(updatedRows);
   // console.log(updatedRows)
  };

  const handleEditRow = (index: number) => {
    const productToEdit = productRows[index];
    setOriginalProduct({ ...productToEdit });
    setEditIndex(index);
    setPopupOpen(true);
    //console.log("Editing product: ", productToEdit);

  };


  // Assuming you're using setProductRows to update the rows



  const handleDiscountChange = (
    index: number,
    field: keyof IDiscount,
    value: any
  ) => {
    const updatedDiscounts = [...discounts];
    updatedDiscounts[index] = {
      ...updatedDiscounts[index],
      [field]: value,
    };
    setDiscounts(updatedDiscounts);
  };

  const handleOpenDialog = (index: number | null) => {
    if (index !== null) {
      const discountToEdit = discounts[index];
      setDiscountValue(discountToEdit.value ?? 0);
      setDiscountType(discountToEdit.type ?? "fixed");
      setDiscountDescription(discountToEdit.description);
      setEditingIndex(index);
    } else {
      setDiscountValue(0);
      setDiscountType("fixed");
      setDiscountDescription("");
      setEditingIndex(null);
    }
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDiscountValue(0);
    setDiscountType("fixed");
    setDiscountDescription("");
    setEditingIndex(null);
  };
  const handleSaveDiscount = () => {
    if (editingIndex !== null) {
      const updatedDiscounts = discounts.map((discount, index) =>
        index === editingIndex
          ? { value: discountValue, type: discountType, description: discountDescription }
          : discount
      );
      setDiscounts(updatedDiscounts);
    } else {
      setDiscounts((prev) => [
        ...prev,
        { value: discountValue, type: discountType, description: discountDescription },
      ]);
    }
    handleCloseDialog();
  };


  const handleDeleteDiscount = (index: number) => {
    const updatedDiscounts = discounts.filter((_, i) => i !== index);
    setDiscounts(updatedDiscounts);
  };

  const formik = useFormik({
    initialValues: {
      companyName: "",
      companyLogo: "",
      companyProvince: "",
      companyCity: "",
      companyPostalCode: "",
      companyStreetNumber: "",
      companyStreetName: "",
      companyMobileNumber: "",
      companyEmail: "",
      companyAddress: "",
      quoteWorkOrderNo: "",
      quoteWorkOrderIssueDate: null,
      quoteWorkOrderDueDate: null,
      quoteWorkOrderStatus: "",
      quoteTripId: "",
      quoteTripName: "",
      customerCompanyName: "",
      customerFirstName: "",
      customerLastName: "",
      customerMobileNum: "",
      customerEmail: "",
      customerProvince: "",
      customerCity: "",
      customerPostalCode: "",
      customerStreetNumber: "",
      customerStreetName: "",
      quoteWorkOrderSale: [],
      quoteWorkOrderSaleDiscount: "",
      quoteWorkOrderSaleSubTotal: "",
      quoteWorkOrderSaleGrandTotal: "",
      quoteWorkOrderSaleDiscountDescription: [],
      quoteWorkOrderCompanyId: "",
      quoteWorkOrderCustomerId: customerId,
      quoteWorkOrderCustomerRemark: "",
      quoteWorkOrderCustomerMemo: "",
    },

    enableReinitialize: true,
    validate: (values) => {
      const errors: { [key: string]: string } = {};

      const mobileNumberError = validatePhoneNumber(values.companyMobileNumber);
      if (mobileNumberError) {
        errors.companyMobileNumber = mobileNumberError;
      }

      const emailError = validateEmail(values.companyEmail);
      if (emailError) {
        errors.companyEmail = emailError;
      }

      const customerMobileNumberError = validatePhoneNumber(
        values.customerMobileNum
      );
      if (customerMobileNumberError) {
        errors.customerMobileNum = customerMobileNumberError;
      }

      const customerEmailError = validateEmail(values.customerEmail);
      if (customerEmailError) {
        errors.customerEmail = customerEmailError;
      }

      return errors;
    },

    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          companyName: values.companyName,
          companyLogo: values.companyLogo,
          companyProvince: values.companyProvince,
          companyCity: values.companyCity,
          companyPostalCode: values.companyPostalCode,
          companyStreetNumber: values.companyStreetNumber,
          companyStreetName: values.companyStreetName,
          companyMobileNumber: values.companyMobileNumber,
          companyEmail: values.companyEmail,
          companyAddress: values.companyAddress,
          quoteWorkOrderNo: generatedWorkOrderNo,
          quoteTripId: values.quoteTripId,
          quoteTripName:  values.quoteTripName,
          quoteWorkOrderIssueDate: values.quoteWorkOrderIssueDate,
          quoteWorkOrderDueDate: values.quoteWorkOrderDueDate,
          quoteWorkOrderStatus: String(values.quoteWorkOrderStatus),
          customerCompanyName: values.customerCompanyName,
           customerFirstName: values.customerFirstName,
          customerLastName: values.customerLastName,
          customerMobileNum: values.customerMobileNum,
          customerEmail: values.customerEmail,

          customerProvince: values.customerProvince,
          customerCity: values.customerCity,
          customerPostalCode: values.customerPostalCode,
          customerStreetNumber: values.customerStreetNumber,
          customerStreetName: values.customerStreetName,


          // Persist datetimes as Toronto wall-clock time (no UTC Z suffix)
          quoteWorkOrderSale: normalizeDateTimeFields(productRows),
          quoteWorkOrderDiscount: String(totalDiscount),
          quoteWorkOrderSubTotal: String(subTotal),
          quoteWorkOrderSaleGrandTotal: String(grandTotalEithDiscount),
          quoteWorkOrderSaleDiscountDescription: discounts,
          quoteWorkOrderCompanyId: String(values.quoteWorkOrderCompanyId),
          quoteWorkOrderCustomerId: String(values.quoteWorkOrderCustomerId),
          quoteWorkOrderCustomerRemark: values.quoteWorkOrderCustomerRemark,
          quoteWorkOrderCustomerMemo: values.quoteWorkOrderCustomerMemo,
        };

        // Step 1: create work order
        const workOrderRes = await newTax(temData).unwrap();
        if (!workOrderRes.status) {
          showErrorMessage(workOrderRes.message);
          return;
        }

        // Step 2: convert the new work order directly to an invoice
        const workOrderId = workOrderRes.data?.id;
        const convertRes = await convertToInvoice({
          mainStatus: "2",
          id: String(workOrderId),
          po_number: poNumber || "",
        }).unwrap();

        if (!convertRes.status) {
          showErrorMessage(convertRes.message || "Failed to create invoice.");
          return;
        }

        showMessage("Invoice created successfully.");
        cancelFunction();
        navigate("/invoice/list");
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  useEffect(() => {
    if (workOrderId !== null) {
      const generatedWorkOrderNo = generateWorkOrderNumber(workOrderId);
      formik.setFieldValue("quoteWorkOrderNo", generatedWorkOrderNo);
      formik.setFieldValue("quoteWorkOrderStatus", WorkOrderStatus?.Initiated);
      formik.setFieldValue("quoteTripId", workOrderId);
    }
  }, [workOrderId]);

  const formatAddress = (
    streetNumber: string,
    streetName: string,
    city: string,
    province: string,
    postalCode: string,
  ) => {
    return `${streetNumber} ${streetName},\n${city}, ${province}, ${postalCode}`;
  };

  const customerFormatAddress = (
    streetNumber: string,
    streetName: string,
    city: string,
    province: string,
    postalCode: string,
  ) => {
    if (!streetNumber && !streetName && !city && !province && !postalCode) {
      return ""; // Return an empty string if all fields are empty
    }

    return `${streetNumber} ${streetName},\n${city}, ${province}, ${postalCode}`;
  };

  const handleSelect = (companyId: string) => {
    const selectedCompany = companyList.find(
      (company) => String(company.id) === companyId
    );
    if (selectedCompany) {
      // setSearchQuery(selectedCompany.companyName);

      const formattedAddress = formatAddress(
        selectedCompany.companyStreetNumber,
        selectedCompany.companyStreetName,
        selectedCompany.companyCity,
        selectedCompany.companyProvince,
        selectedCompany.companyPostalCode,
      );

      formik.setFieldValue("companyName", selectedCompany.companyName);
      formik.setFieldValue(
        "companyStreetNumber",
        selectedCompany.companyStreetNumber
      );
      formik.setFieldValue(
        "companyStreetName",
        selectedCompany.companyStreetName
      );
      formik.setFieldValue("companyProvince", selectedCompany.companyProvince);
      formik.setFieldValue("companyCity", selectedCompany.companyCity);
      formik.setFieldValue(
        "companyPostalCode",
        selectedCompany.companyPostalCode
      );
     

      formik.setFieldValue(
        "companyMobileNumber",
        selectedCompany.companyMobileNumber
      );

      formik.setFieldValue("companyEmail", selectedCompany.companyEmail);
      formik.setFieldValue("quoteWorkOrderCompanyId", selectedCompany.id);

      formik.setFieldValue("companyAddress", formattedAddress);
      setSelectedCompanyLogo(selectedCompany.CompanyLogo);
    }
  };

  // const defaultCompany = companyList.find(
  //   (company) => company.isDefault === 1
  // );

  // const selectedCompanyConst = defaultCompany || companyList[0];

  useEffect(() => {
    if (companyList && companyList.length > 0) {
      const defaultCompany = companyList.find(
        (company) => company.isDefault === 1
      );

      const selectedCompany = defaultCompany || companyList[0];

      if (selectedCompany) {
        setSelectedDefultCompanyId(String(selectedCompany.id));

        const formattedAddress = customerFormatAddress(
          selectedCompany.companyStreetNumber,
          selectedCompany.companyStreetName,
          selectedCompany.companyCity,
          selectedCompany.companyProvince,
          selectedCompany.companyPostalCode,
        );

        formik.setFieldValue("companyName", selectedCompany.companyName);
        formik.setFieldValue(
          "companyStreetNumber",
          selectedCompany.companyStreetNumber
        );
        formik.setFieldValue(
          "companyStreetName",
          selectedCompany.companyStreetName
        );
        formik.setFieldValue("companyCity", selectedCompany.companyCity);
        formik.setFieldValue(
          "companyProvince",
          selectedCompany.companyProvince
        );
       
        formik.setFieldValue(
          "companyPostalCode",
          selectedCompany.companyPostalCode
        );
        formik.setFieldValue(
          "companyMobileNumber",
          selectedCompany.companyMobileNumber
        );
       
       
        formik.setFieldValue("companyEmail", selectedCompany.companyEmail);
        formik.setFieldValue("quoteWorkOrderCompanyId", selectedCompany.id);
        formik.setFieldValue("companyAddress", formattedAddress);
        setSelectedCompanyLogo(selectedCompany.CompanyLogo);
      }
    }
  }, [companyList]);

  useEffect(() => {
    if (customerId && customerList.length > 0) {
      handleSelectCustomer(customerId);
    }
  }, [customerId, customerList]);

  const handleSelectCustomer = (customerId: string) => {
    const selectedCustomer = customerList.find(
      (customer) => String(customer.id) === customerId
    );
    if (selectedCustomer) {
      setSelectedCustomer(selectedCustomer);

      const customerFormattedAddress = customerFormatAddress(
        selectedCustomer.customerStreetNumber,
        selectedCustomer.customerStreetName,
        selectedCustomer.customerCity,
        selectedCustomer.customerProvince,
        selectedCustomer.customerPostalCode,
      );


      setSearchQueryCustomer(
        // (selectedCustomer.customerFirstName || " ") +
        //   " " +
        //   (selectedCustomer.customerLastName || " ")
      //  selectedCustomer.customerCompanyName
        selectedCustomer.customerCompanyName?.trim()
    ? selectedCustomer.customerCompanyName
    : `${selectedCustomer.customerFirstName || ""} ${selectedCustomer.customerLastName || ""}`
      );

      formik.setFieldValue( "customerCompanyName",
        selectedCustomer.customerCompanyName
      );
      formik.setFieldValue(
        "customerFirstName",
        selectedCustomer.customerFirstName || ""
      );
      formik.setFieldValue(
        "customerLastName",
        selectedCustomer.customerLastName
      );
      formik.setFieldValue(
        "customerMobileNum",
        selectedCustomer.customerMobileNum
      );
      formik.setFieldValue("customerEmail", selectedCustomer.customerEmail);
      formik.setFieldValue("customerAddress", customerFormattedAddress);
      formik.setFieldValue("quoteWorkOrderCustomerId", selectedCustomer.id);
    }
    setShowDropdownCustomer(false);
  };

  const cancelFunction = () => {
    formik.resetForm();
    // setSearchQuery("");
    // setCurrentSearchQuery("");
    setSearchQueryCustomer("");
    setCurrentSearchQueryCustomer("");
    setSelectedCustomer(null);
    setSearchQueryProduct("");
    setCurrentSearchQueryProduct("");
    setShowDropdownProductIndex(null);
    // setDiscount(0);
    setDiscountDescription("");
    setSubTotal(0);
    setGrandTotal(0);
    setSelectedCompanyLogo(null);
    // handleSelect(String(selectedCompanyConst));
    setProductRows([
      {
        productName: "",
        productDescription: "",
        productImg: "",
        numberOfPassengers: null || 0,
        busCount: null || 0,
        transferType: TransferType.OneWayTransfer,
        transferTypeFrom: "",
        transferTypeTo: "",
        transferTypeDescription: "",
        departureDateTime: null,
        returnDateTime: null,
        departureAddress: "",
        destinationAddress: "",
        multiDestination: "",
        quantity: 1,
        price: null || 0,
        tax: null || 0,
        taxAmount: null || 0,
        total: 0,
        taxId: null,
        unitPriceWithDiscount: null,
        unitTotalWithDiscount: 0,
        productType: ProductType.Bus,
        productLongDescription: "",
        productShortDescription: "",
      },
    ]);
    setDiscounts([]);
    setTotalDiscount(0);
   // navigate(-1);
  };

  const formValid = useMemo(() => {
    return formik.values.companyName === "" ||
      formik.values.companyName === undefined ||
      formik.values.customerMobileNum === "" ||
      formik.values.customerMobileNum === undefined ||
      formik.values.customerCompanyName === "" ||
      formik.values.customerCompanyName === undefined ||
      formik.values.quoteWorkOrderStatus === "" ||
      formik.values.quoteWorkOrderStatus === undefined
      ? false
      : true;
  }, [formik]);

  useEffect(() => {
      const now = dayjs().tz("America/Toronto");
    if (formik.values.quoteWorkOrderIssueDate === null) {
      formik.setFieldValue("quoteWorkOrderIssueDate", now);
    }
    if (formik.values.quoteWorkOrderDueDate === null) {
          formik.setFieldValue("quoteWorkOrderDueDate",  now.add(5, "day"));
        }
  }, [formik.values.quoteWorkOrderIssueDate, formik.values.quoteWorkOrderDueDate]);

  // useEffect(() => {
  //   if (formik.values.quoteWorkOrderStatus === "") {
  //     if (companyList && companyList.length > 0) {
  //       setSelectedCompanyId(String(companyList[0].id));
  //     }
  //     formik.setFieldValue("quoteWorkOrderStatus", selectedCompanyId);
  //   }
  // }, [formik.values.quoteWorkOrderStatus, companyList]);

  // const loadingFunction = () => {
  //   if (
  //     isLoading ||
  //     taxLoading ||
  //     workOrderIsLoading ||
  //     productIsLoading ||
  //     companyIsLoading ||
  //     customerIsLoading ||
  //     priceHistoryIsLoading
  //   ) {
  //     return (
  //       <Box
  //         display="flex"
  //         justifyContent="center"
  //         alignItems="center"
  //         height="10vh"
  //       >
  //         <CircularProgress />
  //       </Box>
  //     );
  //   }
  // };

  const handleConfirmDialog = () => {
    setOpen(false);
  };

  const rowIdx = editIndex !== null ? editIndex : productRows.length - 1;

  const sectionCard = {
    bgcolor: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: 2,
    mb: 3,
    overflow: "hidden",
  } as const;

  const sectionHeader = {
    px: 3,
    py: 1.5,
    bgcolor: "#f8fafc",
    borderBottom: "1px solid #e2e8f0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  } as const;

  const sectionTitle = {
    fontSize: 13,
    fontWeight: 700,
    color: "#64748b",
    textTransform: "uppercase" as const,
    letterSpacing: 0.8,
  };

  const infoLabel = quoteInfoLabel;
  const InfoBlock = QuoteInfoBlock;

  const formatPhone = (raw: string) => {
    const digits = raw.replace(/\D/g, "").slice(0, 10);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue("customerMobileNum", formatPhone(e.target.value));
  };

  const filterOptions = createFilterOptions({
    matchFrom: "any" as const,
    stringify: (option: any) => {
      if (typeof option === "string") return option;
      return `${option.customerFirstName || ""} ${option.customerLastName || ""} ${option.customerCompanyName || ""} ${option.customerMobileNum || ""} ${option.customerEmail || ""}`;
    },
  });

  const handleNewCustomerAdded = (newCustomer: ICustomer) => {
    cutomerRefetch();
    setSelectedCustomer(newCustomer);
    setSearchQueryCustomer(
      newCustomer.customerCompanyName?.trim()
        ? newCustomer.customerCompanyName
        : `${newCustomer.customerFirstName || ""} ${newCustomer.customerLastName || ""}`.trim()
    );
    handleSelectCustomer(String(newCustomer.id));
  };

  return (
    <Box sx={{ bgcolor: "#f1f5f9", minHeight: "100vh", pb: 4 }}>
      <form onSubmit={formik.handleSubmit}>
        {/* ── Page Header ── */}
        <Box sx={{ px: 3, pt: 3, pb: 2, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography sx={{ fontSize: 22, fontWeight: 700, color: "#1e293b" }}>New Invoice</Typography>
            {formik.values.quoteWorkOrderNo && (
              <Box sx={{ bgcolor: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 1.5, px: 1.5, py: 0.5 }}>
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#2563eb" }}>#{formik.values.quoteWorkOrderNo}</Typography>
              </Box>
            )}
          </Box>
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <Button variant="outlined" startIcon={<CloseIcon />} onClick={cancelFunction} sx={{ borderColor: "#e2e8f0", color: "#64748b", "&:hover": { borderColor: "#94a3b8", bgcolor: "#f8fafc" } }}>Cancel</Button>
            <Button variant="contained" startIcon={<SaveAltIcon />} onClick={() => formik.handleSubmit()} disabled={isLoading} sx={{ bgcolor: "#2563eb", "&:hover": { bgcolor: "#1d4ed8" } }}>Save Invoice</Button>
          </Box>
        </Box>

        <Box sx={{ px: 3 }}>
          {/* ── Section 1: Invoice Details ── */}
          <Box sx={sectionCard}>
            <Box sx={sectionHeader}>
              <Typography sx={sectionTitle}>Invoice Details</Typography>
            </Box>
            <Box sx={{ p: 3 }}>
              <Grid container spacing={3} alignItems="flex-start">
                {/* Logo */}
                <Grid item lg={2} md={3} sm={4} xs={12}>
                  <Box sx={{ border: "1px solid #e2e8f0", borderRadius: 1.5, p: 1.5, display: "flex", alignItems: "center", justifyContent: "center", minHeight: 80, bgcolor: "#f8fafc" }}>
                    {selectedCompanyLogo ? (
                      <img src={`${LARAVEL_API_URL}/${selectedCompanyLogo}`} alt="Company Logo" style={{ maxWidth: "100%", maxHeight: 70, objectFit: "contain" }} />
                    ) : (
                      <Box sx={{ width: 64, height: 64, borderRadius: "50%", bgcolor: "#2f3891", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 800, fontSize: 28 }}>
                        {(formik.values.companyName || "C").charAt(0).toUpperCase()}
                      </Box>
                    )}
                  </Box>
                </Grid>
                {/* Invoice # and Trip ID */}
                <Grid item lg={4} md={4} sm={8} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <InfoBlock label="Invoice Number" value={formik.values.quoteWorkOrderNo} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InfoBlock label="Trip ID" value={(() => {
                        const co = companyList.find((c) => String(c.id) === String(formik.values.quoteWorkOrderCompanyId));
                        const prefix = (co as any)?.companyTripPrefix || "";
                        const raw = formik.values.quoteTripId;
                        if (!raw) return "";
                        return prefix ? `${prefix}${String(raw).padStart(5, "0")}` : String(raw);
                      })()} />
                    </Grid>
                  </Grid>
                </Grid>
                {/* Dates, Status, PO, Trip Name */}
                <Grid item lg={6} md={5} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={{ ...infoLabel, mb: 0.5 }}>Invoice Date</Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={formik.values.quoteWorkOrderIssueDate}
                          onChange={(date) => formik.setFieldValue("quoteWorkOrderIssueDate", date)}
                          slotProps={{ textField: { size: "small", sx: { width: "100%" } } }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={{ ...infoLabel, mb: 0.5 }}>Due Date</Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={formik.values.quoteWorkOrderDueDate}
                          onChange={(date) => formik.setFieldValue("quoteWorkOrderDueDate", date)}
                          slotProps={{ textField: { size: "small", sx: { width: "100%" } } }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={{ ...infoLabel, mb: 0.5 }}>Status</Typography>
                      <TextField
                        select size="small" fullWidth
                        {...formik.getFieldProps("quoteWorkOrderStatus")}
                        defaultValue="Pending"
                        InputLabelProps={{ shrink: true }}
                      >
                        <MenuItem value="" disabled>Select an option</MenuItem>
                        {Object.entries(WorkOrderStatus).map(([key, value], index) => (
                          <MenuItem key={index} value={value}>{key}</MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={{ ...infoLabel, mb: 0.5 }}>PO Number</Typography>
                      <TextField
                        size="small" fullWidth placeholder="Enter PO Number"
                        value={poNumber}
                        onChange={(e) => setPoNumber(e.target.value)}
                        InputProps={{ sx: { fontSize: 14 } }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography sx={{ ...infoLabel, mb: 0.5 }}>Trip Name</Typography>
                      <TextField
                        size="small" fullWidth placeholder="Enter trip name"
                        {...formik.getFieldProps("quoteTripName")}
                        InputProps={{ sx: { fontSize: 14 } }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* ── Section 2: Parties ── */}
          <Box sx={sectionCard}>
            <Box sx={sectionHeader}>
              <Typography sx={sectionTitle}>Parties</Typography>
            </Box>
            <Box sx={{ p: 0 }}>
              <Grid container>
                {/* Issue From */}
                <Grid item lg={6} md={6} sm={12} xs={12} sx={{ borderRight: { md: "1px solid #e2e8f0" } }}>
                  <Box sx={{ p: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                      <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.8 }}>Issue From</Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <TextField
                          select size="small"
                          value={selectedDefultCompanyId}
                          onChange={(event) => {
                            const selectedId = event.target.value;
                            setSelectedDefultCompanyId(selectedId);
                            handleSelect(selectedId);
                          }}
                          sx={{ minWidth: 160 }}
                          InputLabelProps={{ shrink: true }}
                        >
                          <MenuItem value="" disabled style={{ color: "gray" }}>Select company</MenuItem>
                          {companyList && companyList.map((company) => (
                            <MenuItem key={company.id} value={String(company.id)}>{company.companyName}</MenuItem>
                          ))}
                        </TextField>
                        <Button size="small" variant="outlined" onClick={() => setOpenCompany(true)} sx={{ minWidth: 36, px: 1, borderColor: "#e2e8f0", color: "#64748b" }}><AddIcon fontSize="small" /></Button>
                      </Box>
                    </Box>
                    <Grid container spacing={2}>
                      <Grid item xs={12}><InfoBlock label="Company Name" value={formik.values.companyName} /></Grid>
                      <Grid item xs={12}><InfoBlock label="Address" value={formik.values.companyAddress} /></Grid>
                      <Grid item xs={6}><InfoBlock label="Phone" value={formik.values.companyMobileNumber} /></Grid>
                      <Grid item xs={6}><InfoBlock label="Email" value={formik.values.companyEmail} /></Grid>
                    </Grid>
                  </Box>
                </Grid>
                {/* Issue For */}
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <Box sx={{ p: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                      <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.8 }}>Issue For</Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1, ml: 2 }}>
                        <Autocomplete
                          fullWidth
                          options={[...customerList].sort((a, b) => {
                            const label = (c: typeof a) => {
                              const name = `${c.customerFirstName || ""} ${c.customerLastName || ""}`.trim();
                              return (name || c.customerCompanyName || "").toLowerCase();
                            };
                            return label(a).localeCompare(label(b));
                          })}
                          getOptionLabel={(option) => {
                            if (typeof option === "string") return option;
                            const name = `${option.customerFirstName || ""} ${option.customerLastName || ""}`.trim();
                            return name || option.customerCompanyName || "";
                          }}
                          filterOptions={filterOptions}
                          value={selectedCustomer || null}
                          inputValue={searchQueryCustomer}
                          loading={customerIsLoading}
                          onChange={(_event, newValue) => {
                            if (typeof newValue === "object" && newValue !== null) {
                              handleSelectCustomer(String(newValue.id));
                              setSearchQueryCustomer(fmtCustomerName(newValue));
                            } else {
                              setSelectedCustomer(null);
                              handleSelectCustomer("");
                            }
                          }}
                          onInputChange={(_event, newInputValue, reason) => {
                            setSearchQueryCustomer(newInputValue);
                            if (reason === "clear" || newInputValue === "") setSelectedCustomer(null);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search customer"
                              size="small"
                              error={showCustomerError && !selectedCustomer}
                              helperText={showCustomerError && !selectedCustomer ? "Customer is required" : ""}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Box sx={{ pr: 1 }}><CiSearch style={{ fontSize: 16, color: "#94a3b8" }} /></Box>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          )}
                        />
                        <Button size="small" variant="outlined" onClick={() => setOpenCustomer(true)} sx={{ minWidth: 36, px: 1, borderColor: "#e2e8f0", color: "#64748b" }}><AddIcon fontSize="small" /></Button>
                      </Box>
                    </Box>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <InfoBlock
                          label="Name"
                          value={
                            formik.values.customerCompanyName?.trim()
                              ? formik.values.customerCompanyName
                              : `${formik.values.customerFirstName || ""} ${formik.values.customerLastName || ""}`.trim()
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={quoteInfoLabel}>Phone</Typography>
                        <TextField
                          size="small" fullWidth placeholder="(XXX) XXX-XXXX"
                          value={formik.values.customerMobileNum || ""}
                          onChange={handlePhoneChange}
                          onBlur={() => formik.setFieldTouched("customerMobileNum", true)}
                          error={formik.touched.customerMobileNum && !!formik.errors.customerMobileNum}
                          helperText={formik.touched.customerMobileNum && formik.errors.customerMobileNum}
                          inputProps={{ maxLength: 14 }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Typography sx={{ fontSize: 13, color: "#94a3b8", lineHeight: 1 }}>📞</Typography>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={quoteInfoLabel}>Email</Typography>
                        <TextField
                          size="small" fullWidth placeholder="email@example.com"
                          value={formik.values.customerEmail || ""}
                          onChange={(e) => formik.setFieldValue("customerEmail", e.target.value)}
                          onBlur={() => formik.setFieldTouched("customerEmail", true)}
                          error={formik.touched.customerEmail && !!formik.errors.customerEmail}
                          helperText={formik.touched.customerEmail && formik.errors.customerEmail}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Typography sx={{ fontSize: 13, color: "#94a3b8", lineHeight: 1 }}>✉️</Typography>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* ── Section 3: Services ── */}
          <Box sx={sectionCard}>
            <Box sx={sectionHeader}>
              <Typography sx={sectionTitle}>Services</Typography>
              <Button variant="contained" size="small" startIcon={<AddIcon />} onClick={handleAddRow} sx={{ bgcolor: "#2563eb", "&:hover": { bgcolor: "#1d4ed8" }, fontSize: 13 }}>Add Trip</Button>
            </Box>
            <Box sx={{ p: 0 }}>
              {productRows.length === 0 ? (
                <Box sx={{ py: 6, textAlign: "center" }}>
                  <Typography sx={{ color: "#94a3b8", fontSize: 14 }}>No trips added yet. Click "Add Trip" to start.</Typography>
                </Box>
              ) : (
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow sx={{ bgcolor: "#f8fafc" }}>
                        <TableCell sx={{ fontWeight: 700, fontSize: 12, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.6, borderBottom: "1px solid #e2e8f0" }}>Bus & Services</TableCell>
                        <TableCell sx={{ fontWeight: 700, fontSize: 12, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.6, borderBottom: "1px solid #e2e8f0" }}>Trip Information</TableCell>
                        <TableCell sx={{ fontWeight: 700, fontSize: 12, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.6, borderBottom: "1px solid #e2e8f0" }}>Price</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 700, fontSize: 12, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.6, borderBottom: "1px solid #e2e8f0" }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {productRows.map((product, index) => (
                        <TableRow key={index} sx={{ "&:last-child td": { borderBottom: 0 }, "&:hover": { bgcolor: "#f8fafc" } }}>
                          <TableCell sx={{ verticalAlign: "top", borderBottom: "1px solid #f1f5f9", py: 2 }}>
                            <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1e293b" }}>{product.productName || ""}</Typography>
                            <Typography sx={{ fontSize: 12, color: "#64748b", mt: 0.25 }}>{product.productDescription || ""}</Typography>
                            {(product.numberOfPassengers || product.busCount) && (
                              <Typography sx={{ fontSize: 12, color: "#64748b", mt: 0.25 }}>
                                {product.numberOfPassengers ? `${product.numberOfPassengers} pax` : ""}
                                {product.numberOfPassengers && product.busCount ? " · " : ""}
                                {product.busCount ? `${product.busCount} bus` : ""}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell sx={{ verticalAlign: "top", borderBottom: "1px solid #f1f5f9", py: 2 }}>
                            <Typography sx={{ fontSize: 13, fontWeight: 500, color: "#334155" }}>
                              {product.transferType ? (Object.keys(TransferType) as (keyof typeof TransferType)[]).find((key) => TransferType[key] === String(product.transferType)) : ""}
                              {product.transferTypeFrom && product.transferTypeTo ? ` (${product.transferTypeFrom} → ${product.transferTypeTo})` : ""}
                            </Typography>
                            {product.departureAddress && (
                              <Typography sx={{ fontSize: 12, color: "#64748b", mt: 0.5 }}>
                                <strong>Departure:</strong> {product.departureAddress}
                                {product.departureDateTime && dayjs(product.departureDateTime).isValid() && <> · {dayjs(product.departureDateTime as any).format("DD-MMM-YY hh:mm A")}</>}
                              </Typography>
                            )}
                            {product.destinationAddress && (
                              <Typography sx={{ fontSize: 12, color: "#64748b", mt: 0.5 }}>
                                <strong>Destination:</strong> {product.destinationAddress}
                                {product.returnDateTime && dayjs(product.returnDateTime).isValid() && <> · {dayjs(product.returnDateTime as any).format("DD-MMM-YY hh:mm A")}</>}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell sx={{ verticalAlign: "top", borderBottom: "1px solid #f1f5f9", py: 2 }}>
                            <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#1e293b" }}>
                              ${product.total != null ? product.total.toFixed(2) : "0.00"}
                            </Typography>
                            {product.price != null && product.busCount != null && product.busCount > 1 && (
                              <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.25 }}>
                                ${product.price.toFixed(2)} × {product.busCount} buses
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell align="right" sx={{ verticalAlign: "top", borderBottom: "1px solid #f1f5f9", py: 2 }}>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 0.5 }}>
                              <IconButton size="small" color="primary" onClick={() => handleEditRow(index)} sx={{ "&:hover": { bgcolor: "#eff6ff" } }}>
                                <FaEdit style={{ fontSize: 15 }} />
                              </IconButton>
                              <IconButton size="small" color="error" onClick={() => handleDeleteRow(index)} sx={{ "&:hover": { bgcolor: "#fef2f2" } }}>
                                <FaTrash style={{ fontSize: 14 }} />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>
          </Box>

          {/* ── Trip Dialog ── */}
          <Dialog open={popupOpen} onClose={() => setPopupOpen(false)} maxWidth="lg" fullWidth
            PaperProps={{ sx: { borderRadius: 2.5, overflow: "hidden", maxHeight: "92vh" } }}>
            <Box sx={{ px: 3, py: 2, background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box sx={{ width: 36, height: 36, borderRadius: 1.5, bgcolor: "rgba(255,255,255,0.12)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Typography sx={{ fontSize: 18 }}>🚌</Typography>
                </Box>
                <Typography sx={{ fontWeight: 700, fontSize: 16, color: "#ffffff" }}>
                  {editIndex !== null ? "Edit Trip" : "Add Trip"}
                </Typography>
              </Box>
              <IconButton size="small" onClick={handleCancel} sx={{ color: "#94a3b8", "&:hover": { color: "#ffffff", bgcolor: "rgba(255,255,255,0.1)" } }}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            <DialogContent sx={{ p: 0, overflowY: "auto" }}>
              <Grid container>
                {/* Left: Bus Info + Pricing */}
                <Grid item xs={12} md={4} sx={{ borderRight: { md: "1px solid #e2e8f0" }, bgcolor: "#f8fafc" }}>
                  <Box sx={{ p: 3 }}>
                    <Box sx={{ mb: 3, position: "relative" }}>
                      <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.8, mb: 1.5 }}>Bus / Service</Typography>
                      <TextField
                        size="small" fullWidth
                        value={productRows[rowIdx]?.productName || ""}
                        onChange={(e) => { handleProductNameChange(rowIdx, e.target.value); if (errors.productName) setErrors((p) => ({ ...p, productName: undefined })); }}
                        placeholder="Search bus or service..."
                        error={!!errors.productName}
                        helperText={errors.productName}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CiSearch style={{ fontSize: 16, color: "#94a3b8" }} />
                            </InputAdornment>
                          ),
                          sx: { bgcolor: "#ffffff" },
                        }}
                        onFocus={() => setShowDropdownProductIndex(rowIdx)}
                      />
                      {showDropdownProductIndex === rowIdx && (
                        <Paper sx={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 9999, mt: 0.5, maxHeight: 200, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 1.5, boxShadow: "0 8px 24px rgba(0,0,0,0.12)" }}>
                          {productIsLoading ? (
                            <Box sx={{ textAlign: "center", p: 2 }}><CircularProgress size={20} /></Box>
                          ) : (
                            productList.map((Product) => (
                              <MenuItem key={Product.id} onClick={() => handleProductSelect(Product, rowIdx)}
                                sx={{ gap: 1.5, py: 1, "&:hover": { bgcolor: "#eff6ff" } }}>
                                <img
                                  src={Product.productImg ? `${LARAVEL_API_URL}/${String(Product.productImg)}` : placeholderImage}
                                  alt="img"
                                  style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 6 }}
                                />
                                <Typography sx={{ fontSize: 13, fontWeight: 500 }}>{Product.productName}</Typography>
                              </MenuItem>
                            ))
                          )}
                        </Paper>
                      )}
                    </Box>

                    <Box sx={{ mb: 3 }}>
                      <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.8, mb: 1.5 }}>Trip Details</Typography>
                      <Grid container spacing={1.5}>
                        <Grid item xs={6}>
                          <Typography sx={{ ...infoLabel, mb: 0.5 }}>Passengers</Typography>
                          <TextField size="small" fullWidth type="number" placeholder="0"
                            value={productRows[rowIdx]?.numberOfPassengers || ""}
                            onChange={(e) => { handleFieldChange(rowIdx, "numberOfPassengers", Number(e.target.value)); if (errors.numberOfPassengers) setErrors((p) => ({ ...p, numberOfPassengers: undefined })); }}
                            error={!!errors.numberOfPassengers}
                            helperText={errors.numberOfPassengers}
                            InputProps={{ inputProps: { min: 0 }, sx: { bgcolor: "#ffffff" } }} />
                        </Grid>
                        <Grid item xs={6}>
                          <Typography sx={{ ...infoLabel, mb: 0.5 }}>Bus Count</Typography>
                          <TextField size="small" fullWidth type="number" placeholder="1"
                            value={productRows[rowIdx]?.busCount || ""}
                            onChange={(e) => { handleFieldChange(rowIdx, "busCount", Number(e.target.value)); if (errors.busCount) setErrors((p) => ({ ...p, busCount: undefined })); }}
                            error={!!errors.busCount}
                            helperText={errors.busCount}
                            InputProps={{ inputProps: { min: 0 }, sx: { bgcolor: "#ffffff" } }} />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography sx={{ ...infoLabel, mb: 0.5 }}>Transfer Type</Typography>
                          <TextField select size="small" fullWidth
                            value={productRows[rowIdx]?.transferType ?? ""}
                            onChange={(e) => { handleFieldChange(rowIdx, "transferType", String(e.target.value)); if (errors.transferType) setErrors((p) => ({ ...p, transferType: undefined })); }}
                            error={!!errors.transferType}
                            helperText={errors.transferType}
                            InputProps={{ sx: { bgcolor: "#ffffff" } }}>
                            <MenuItem value="" disabled>Select type</MenuItem>
                            {Object.entries(TransferType).map(([key, value], i) => (
                              <MenuItem key={i} value={value}>{key}</MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Box>

                    <Box sx={{ mb: 3 }}>
                      <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.8, mb: 1.5 }}>Pricing</Typography>
                      {priceHistoryIsLoading && <Box sx={{ textAlign: "center", py: 1 }}><CircularProgress size={18} /></Box>}
                      {nextPrice && (
                        <Box sx={{ mb: 1.5, p: 1.5, bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 1.5 }}>
                          <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#16a34a", textTransform: "uppercase", letterSpacing: 0.5, mb: 0.5 }}>Price History</Typography>
                          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                            <Box>
                              <Typography sx={{ fontSize: 10, color: "#64748b" }}>Last Price</Typography>
                              <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#1e293b" }}>{nextPrice}</Typography>
                              <Typography sx={{ fontSize: 11, color: "#64748b" }}>{busCount} bus{busCount !== 1 ? "es" : ""}</Typography>
                            </Box>
                            <Box>
                              <Typography sx={{ fontSize: 10, color: "#64748b" }}>Average</Typography>
                              <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#1e293b" }}>{averagePrice}</Typography>
                              {updated_at && <Typography sx={{ fontSize: 10, color: "#94a3b8" }}>{new Date(updated_at).toLocaleDateString()}</Typography>}
                            </Box>
                          </Box>
                          {quoteWorkOrderNo && (
                            <Typography sx={{ fontSize: 11, color: "#2563eb", fontWeight: 600, cursor: "pointer", textDecoration: "underline", mt: 0.5 }}
                              onClick={() => window.open(`/work-order/history/${priceId}`, "_blank")}>
                              View: {quoteWorkOrderNo}
                            </Typography>
                          )}
                        </Box>
                      )}
                      {priceHistoryError && currentIndex !== null && (
                        <Alert severity="error" sx={{ mb: 1.5, py: 0.5, fontSize: 12 }}>
                          Error loading price history for {productRows[currentIndex]?.productName}.
                        </Alert>
                      )}
                      <Grid container spacing={1.5}>
                        <Grid item xs={12}>
                          <Typography sx={{ ...infoLabel, mb: 0.5 }}>Trip Price ($)</Typography>
                          <TextField size="small" fullWidth type="number" placeholder="0.00"
                            value={productRows[rowIdx]?.price || ""}
                            onChange={(e) => { handlePriceChange(rowIdx, Math.max(0, Number(e.target.value))); if (errors.price) setErrors((p) => ({ ...p, price: undefined })); }}
                            error={!!errors.price}
                            helperText={errors.price}
                            InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment>, sx: { bgcolor: "#ffffff" } }} />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography sx={{ ...infoLabel, mb: 0.5 }}>Tax</Typography>
                          <TextField select size="small" fullWidth
                            value={productRows[rowIdx]?.tax || 0}
                            onChange={(e) => {
                              const taxPercentage = Number(e.target.value);
                              const productPrice = productRows[rowIdx]?.price || 0;
                              const newTaxAmount = productPrice * (taxPercentage / 100);
                              handleFieldChange(rowIdx, "tax", taxPercentage);
                              handleFieldChange(rowIdx, "taxAmount", newTaxAmount);
                            }}
                            InputProps={{ sx: { bgcolor: "#ffffff" } }}>
                            <MenuItem value={0}>No Tax</MenuItem>
                            {taxList && taxList.map((tax) => (
                              <MenuItem key={tax.id} value={tax.percentage}>{tax.taxName} – {tax.percentage}%</MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                        {(productRows[rowIdx]?.tax || 0) > 0 && (
                          <Grid item xs={12}>
                            <Box sx={{ p: 1.5, bgcolor: "#ffffff", border: "1px solid #e2e8f0", borderRadius: 1.5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <Typography sx={{ fontSize: 12, color: "#64748b" }}>Tax Amount</Typography>
                              <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#1e293b" }}>${productRows[rowIdx]?.taxAmount?.toFixed(2) || "0.00"}</Typography>
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </Box>

                    <Box>
                      <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.8, mb: 1.5 }}>Description</Typography>
                      <TextField size="small" fullWidth multiline rows={4} placeholder="Additional notes about this trip..."
                        value={productRows[rowIdx]?.productDescription || ""}
                        onChange={(e) => handleFieldChange(rowIdx, "productDescription", e.target.value)}
                        InputProps={{ sx: { bgcolor: "#ffffff" } }} />
                    </Box>
                  </Box>
                </Grid>

                {/* Right: Route */}
                <Grid item xs={12} md={8}>
                  <Box sx={{ p: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                      <Box sx={{ width: 4, height: 20, bgcolor: "#2563eb", borderRadius: 2 }} />
                      <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#1e293b" }}>Route Information</Typography>
                    </Box>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography sx={{ ...infoLabel, mb: 0.5 }}>Departure Address</Typography>
                        <TextField size="small" fullWidth placeholder="Enter departure address..."
                          value={productRows[rowIdx]?.departureAddress || ""}
                          onChange={(e) => handleFieldChange(rowIdx, "departureAddress", e.target.value)}
                          InputProps={{ sx: { bgcolor: "#ffffff" } }} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography sx={{ ...infoLabel, mb: 0.5 }}>Departure City</Typography>
                        <Autocomplete
                          options={canadianCities.filter((v, i, self) => self.indexOf(v) === i)}
                          value={productRows[rowIdx]?.transferTypeFrom || ""}
                          onChange={(_e, newValue) => handleFieldChange(rowIdx, "transferTypeFrom", newValue ?? "")}
                          getOptionLabel={(option) => option}
                          filterOptions={(options, state) => {
                            const inputValue = state.inputValue.toLowerCase();
                            return [
                              ...options.filter(o => o.toLowerCase() === inputValue),
                              ...options.filter(o => o.toLowerCase().includes(inputValue) && o.toLowerCase() !== inputValue),
                            ];
                          }}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select city..." size="small" InputProps={{ ...params.InputProps, sx: { bgcolor: "#ffffff" } }} />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography sx={{ ...infoLabel, mb: 0.5 }}>Destination Address</Typography>
                        <TextField size="small" fullWidth placeholder="Enter destination address..."
                          value={productRows[rowIdx]?.destinationAddress || ""}
                          onChange={(e) => handleFieldChange(rowIdx, "destinationAddress", e.target.value)}
                          InputProps={{ sx: { bgcolor: "#ffffff" } }} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography sx={{ ...infoLabel, mb: 0.5 }}>Destination City</Typography>
                        <Autocomplete
                          options={canadianCities.filter((v, i, self) => self.indexOf(v) === i)}
                          value={productRows[rowIdx]?.transferTypeTo || ""}
                          onChange={(_e, newValue) => handleFieldChange(rowIdx, "transferTypeTo", newValue ?? "")}
                          getOptionLabel={(option) => option}
                          filterOptions={(options, state) => {
                            const inputValue = state.inputValue.toLowerCase();
                            return [
                              ...options.filter(o => o.toLowerCase() === inputValue),
                              ...options.filter(o => o.toLowerCase().includes(inputValue) && o.toLowerCase() !== inputValue),
                            ];
                          }}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select city..." size="small" InputProps={{ ...params.InputProps, sx: { bgcolor: "#ffffff" } }} />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography sx={{ ...infoLabel, mb: 0.5 }}>Departure Date & Time</Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DateTimePicker
                            value={productRows[rowIdx]?.departureDateTime}
                            onChange={(value) => handleFieldChange(rowIdx, "departureDateTime", value)}
                            minDate={dayjs()}
                            slotProps={{
                              textField: {
                                placeholder: "Departure Date & Time",
                                size: "small",
                                sx: { width: "100%", bgcolor: "#ffffff" },
                                error: !!errors.departureDateTime,
                                helperText: errors.departureDateTime || "",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                      {productRows[rowIdx]?.transferType !== TransferType.OneWayTransfer && (
                        <Grid item xs={12} sm={6}>
                          <Typography sx={{ ...infoLabel, mb: 0.5 }}>Return Date & Time</Typography>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                              value={productRows[rowIdx]?.returnDateTime}
                              onChange={(value) => handleFieldChange(rowIdx, "returnDateTime", value)}
                              minDateTime={
                                productRows[rowIdx]?.departureDateTime
                                  ? dayjs(productRows[rowIdx]?.departureDateTime as any)
                                  : undefined
                              }
                              slotProps={{
                                textField: {
                                  placeholder: "Return Date & Time",
                                  size: "small",
                                  sx: { width: "100%", bgcolor: "#ffffff" },
                                  error: !!errors.returnDateTime,
                                  helperText: errors.returnDateTime || "",
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>

            <Box sx={{ px: 3, py: 2, borderTop: "1px solid #e2e8f0", bgcolor: "#f8fafc", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1.5 }}>
              <Button variant="outlined" startIcon={<CloseIcon />} onClick={handleCancel}
                sx={{ borderColor: "#e2e8f0", color: "#64748b", "&:hover": { borderColor: "#94a3b8", bgcolor: "#f1f5f9" } }}>
                Cancel
              </Button>
              <Button variant="contained" startIcon={<SaveAltIcon />} onClick={handleSaveProduct}
                sx={{ bgcolor: "#2563eb", "&:hover": { bgcolor: "#1d4ed8" }, px: 3 }}>
                {editIndex !== null ? "Update Trip" : "Save Trip"}
              </Button>
            </Box>
          </Dialog>

          {/* ── Section 4: Discounts & Summary ── */}
          <Box sx={sectionCard}>
            <Box sx={sectionHeader}>
              <Typography sx={sectionTitle}>Discounts & Summary</Typography>
              <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={() => handleOpenDialog(null)} sx={{ borderColor: "#2563eb", color: "#2563eb", fontSize: 13 }}>Add Discount</Button>
            </Box>
            <Box sx={{ p: 3 }}>
              <Grid container spacing={4}>
                <Grid item lg={8} md={7} sm={12} xs={12}>
                  {discounts.length === 0 ? (
                    <Typography sx={{ color: "#94a3b8", fontSize: 13 }}>No discounts applied.</Typography>
                  ) : (
                    discounts.map((discount, index) => (
                      <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5, p: 1.5, border: "1px solid #e2e8f0", borderRadius: 1.5, bgcolor: "#f8fafc" }}>
                        <Box sx={{ flex: 1 }}>
                          <Typography sx={{ fontSize: 13, fontWeight: 500, color: "#334155" }}>{discount.description || "Discount"}</Typography>
                        </Box>
                        <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#dc2626" }}>
                          {discount.type === "percent"
                            ? `-${(discount.value ?? 0).toFixed(1)}% (-$${(((discount.value ?? 0) / 100) * subTotal).toFixed(2)})`
                            : `-$${(discount.value ?? 0).toFixed(2)}`}
                        </Typography>
                        <IconButton size="small" onClick={() => handleOpenDialog(index)} sx={{ color: "#2563eb" }}><FaEdit style={{ fontSize: 13 }} /></IconButton>
                        <IconButton size="small" onClick={() => handleDeleteDiscount(index)} sx={{ color: "#dc2626" }}><FaTrash style={{ fontSize: 12 }} /></IconButton>
                      </Box>
                    ))
                  )}
                </Grid>
                <Grid item lg={4} md={5} sm={12} xs={12}>
                  <Box sx={{ border: "1px solid #e2e8f0", borderRadius: 2, overflow: "hidden" }}>
                    {[
                      { label: "Subtotal", value: `$${subTotal.toFixed(2)}`, color: "#1e293b" },
                      { label: "Total Discount", value: `-$${totalDiscount.toFixed(2)}`, color: "#dc2626" },
                      { label: "HST", value: `$${taxAmount.toFixed(2)}`, color: "#1e293b" },
                    ].map((row) => (
                      <Box key={row.label} sx={{ display: "flex", justifyContent: "space-between", px: 2, py: 1.25, borderBottom: "1px solid #f1f5f9" }}>
                        <Typography sx={{ fontSize: 13, color: "#64748b" }}>{row.label}</Typography>
                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: row.color }}>{row.value}</Typography>
                      </Box>
                    ))}
                    <Box sx={{ display: "flex", justifyContent: "space-between", px: 2, py: 1.5, bgcolor: "#1e293b" }}>
                      <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#ffffff" }}>Grand Total</Typography>
                      <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#ffffff" }}>
                        ${isNaN(grandTotalEithDiscount) ? "0.00" : (grandTotalEithDiscount ?? 0).toFixed(2)}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* ── Section 5: Remarks ── */}
          <Box sx={sectionCard}>
            <Box sx={sectionHeader}>
              <Typography sx={sectionTitle}>Remarks</Typography>
            </Box>
            <Box sx={{ p: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography sx={{ ...infoLabel, mb: 0.5 }}>Special Notification</Typography>
                  <TextField
                    placeholder="Enter special notification for customer (visible on invoice/PDF/email)..."
                    size="small" fullWidth multiline rows={6}
                    {...formik.getFieldProps("quoteWorkOrderCustomerRemark")}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography sx={{ ...infoLabel, mb: 0.5 }}>Internal / Office Notes</Typography>
                  <TextField
                    placeholder="Enter internal notes (admin-only, not on invoice/PDF/email)..."
                    size="small" fullWidth multiline rows={6}
                    {...formik.getFieldProps("quoteWorkOrderCustomerMemo")}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* ── Bottom Action Bar ── */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, pb: 2 }}>
            <Button variant="outlined" startIcon={<CloseIcon />} onClick={cancelFunction} sx={{ borderColor: "#e2e8f0", color: "#64748b", "&:hover": { borderColor: "#94a3b8", bgcolor: "#f8fafc" } }}>Cancel</Button>
            <Button variant="contained" startIcon={<SaveAltIcon />} onClick={() => formik.handleSubmit()} disabled={isLoading} sx={{ bgcolor: "#2563eb", "&:hover": { bgcolor: "#1d4ed8" } }}>Save Invoice</Button>
          </Box>

          {/* ── Discount Dialog ── */}
          <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="xs" fullWidth
            PaperProps={{ sx: { borderRadius: 2.5, overflow: "hidden" } }}>
            <Box sx={{ px: 3, py: 2, background: "linear-gradient(135deg, #2f3891 0%, #252e7a 100%)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box sx={{ width: 36, height: 36, borderRadius: 1.5, bgcolor: "rgba(255,255,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Typography sx={{ fontSize: 18, lineHeight: 1 }}>🏷️</Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontWeight: 700, fontSize: 15, color: "#ffffff", lineHeight: 1.2 }}>
                    {editingIndex !== null ? "Edit Discount" : "Add Discount"}
                  </Typography>
                  <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.65)", mt: 0.25 }}>
                    Subtotal: ${subTotal.toFixed(2)}
                  </Typography>
                </Box>
              </Box>
              <IconButton size="small" onClick={handleCloseDialog}
                sx={{ color: "rgba(255,255,255,0.7)", "&:hover": { color: "#ffffff", bgcolor: "rgba(255,255,255,0.12)" } }}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            <DialogContent sx={{ p: 3 }}>
              <Box sx={{ mb: 2.5 }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
                  <Typography sx={infoLabel}>Discount Amount</Typography>
                  <Box sx={{ display: "flex", border: "1.5px solid #e2e8f0", borderRadius: 1.5, overflow: "hidden" }}>
                    {(["fixed", "percent"] as const).map((t) => (
                      <Box key={t} onClick={() => { setDiscountType(t); setDiscountValue(0); }}
                        sx={{ px: 1.5, py: 0.4, fontSize: 13, fontWeight: 700, cursor: "pointer", userSelect: "none", transition: "all 0.15s",
                          bgcolor: discountType === t ? "#2f3891" : "#f8fafc",
                          color: discountType === t ? "#ffffff" : "#64748b",
                          "&:hover": discountType !== t ? { bgcolor: "#f5f3ff", color: "#2f3891" } : {},
                        }}>
                        {t === "fixed" ? "$" : "%"}
                      </Box>
                    ))}
                  </Box>
                </Box>
                <TextField
                  fullWidth type="number" placeholder="0"
                  value={discountValue || ""}
                  onChange={(e) => {
                    const v = Math.max(0, Number(e.target.value));
                    setDiscountValue(discountType === "percent" ? Math.min(100, v) : v);
                  }}
                  inputProps={{ min: 0, step: discountType === "percent" ? 1 : 0.01, max: discountType === "percent" ? 100 : undefined }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography sx={{ fontSize: 20, fontWeight: 700, color: "#2f3891", lineHeight: 1 }}>
                          {discountType === "fixed" ? "$" : "%"}
                        </Typography>
                      </InputAdornment>
                    ),
                    sx: { fontSize: 28, fontWeight: 700, color: "#1e293b", "& input": { py: 1.5 } },
                  }}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#2f3891", borderWidth: 2 } } }}
                />
                {discountType === "percent" && discountValue > 0 && subTotal > 0 && (
                  <Typography sx={{ fontSize: 12, color: "#2f3891", mt: 0.5, fontWeight: 600 }}>
                    = ${((discountValue / 100) * subTotal).toFixed(2)} off
                  </Typography>
                )}
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography sx={{ ...infoLabel, mb: 1 }}>Quick {discountType === "fixed" ? "Amounts" : "Percentages"}</Typography>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  {(discountType === "fixed" ? [25, 50, 100, 150, 200, 500] : [5, 10, 15, 20, 25, 50]).map((preset) => (
                    <Box key={preset} onClick={() => setDiscountValue(preset)}
                      sx={{ px: 1.5, py: 0.6, borderRadius: 1.5, border: "1.5px solid",
                        borderColor: discountValue === preset ? "#2f3891" : "#e2e8f0",
                        bgcolor: discountValue === preset ? "#f5f3ff" : "#f8fafc",
                        color: discountValue === preset ? "#2f3891" : "#64748b",
                        fontWeight: discountValue === preset ? 700 : 500,
                        fontSize: 13, cursor: "pointer", userSelect: "none", transition: "all 0.15s",
                        "&:hover": { borderColor: "#2f3891", bgcolor: "#f5f3ff", color: "#2f3891" },
                      }}>
                      {discountType === "fixed" ? `$${preset}` : `${preset}%`}
                    </Box>
                  ))}
                </Box>
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography sx={{ ...infoLabel, mb: 1 }}>Description (optional)</Typography>
                <TextField
                  fullWidth multiline rows={3}
                  placeholder="e.g. Loyalty discount, group rate, promo code..."
                  value={discountDescription}
                  onChange={(e) => setDiscountDescription(e.target.value)}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#2f3891" } } }}
                />
              </Box>

              {discountValue > 0 && (() => {
                const thisDiscountDollar = discountType === "percent" ? (discountValue / 100) * subTotal : discountValue;
                const otherDiscountsDollar = discounts.reduce((a, d, i) => {
                  if (i === editingIndex) return a;
                  return a + (d.type === "percent" ? ((d.value ?? 0) / 100) * subTotal : (d.value ?? 0));
                }, 0);
                const newTotal = Math.max(0, subTotal - thisDiscountDollar - otherDiscountsDollar + taxAmount);
                return (
                  <Box sx={{ borderRadius: 2, overflow: "hidden", border: "1px solid #e2e8f0" }}>
                    <Box sx={{ px: 2, py: 1, bgcolor: "#f8fafc", borderBottom: "1px solid #f1f5f9" }}>
                      <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.6 }}>Preview</Typography>
                    </Box>
                    {[
                      { label: "Subtotal", value: `$${subTotal.toFixed(2)}`, color: "#1e293b", bold: false },
                      { label: discountType === "percent" ? `This discount (${discountValue}%)` : "This discount", value: `-$${thisDiscountDollar.toFixed(2)}`, color: "#dc2626", bold: true },
                      { label: "Other discounts", value: `-$${otherDiscountsDollar.toFixed(2)}`, color: "#64748b", bold: false },
                      { label: "Tax (HST)", value: `$${taxAmount.toFixed(2)}`, color: "#64748b", bold: false },
                    ].map((row) => (
                      <Box key={row.label} sx={{ display: "flex", justifyContent: "space-between", px: 2, py: 0.8, borderBottom: "1px solid #f1f5f9" }}>
                        <Typography sx={{ fontSize: 13, color: "#64748b" }}>{row.label}</Typography>
                        <Typography sx={{ fontSize: 13, fontWeight: row.bold ? 700 : 500, color: row.color }}>{row.value}</Typography>
                      </Box>
                    ))}
                    <Box sx={{ display: "flex", justifyContent: "space-between", px: 2, py: 1.25, bgcolor: "#1e293b" }}>
                      <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#ffffff" }}>New Grand Total</Typography>
                      <Typography sx={{ fontSize: 15, fontWeight: 800, color: "#ffffff" }}>${newTotal.toFixed(2)}</Typography>
                    </Box>
                  </Box>
                );
              })()}
            </DialogContent>

            <Box sx={{ px: 3, py: 2, borderTop: "1px solid #e2e8f0", bgcolor: "#f8fafc", display: "flex", gap: 1.5, justifyContent: "flex-end" }}>
              <Button variant="outlined" onClick={handleCloseDialog}
                sx={{ borderColor: "#e2e8f0", color: "#64748b", "&:hover": { borderColor: "#94a3b8", bgcolor: "#f1f5f9" } }}>
                Cancel
              </Button>
              <Button variant="contained" startIcon={<SaveAltIcon />} onClick={handleSaveDiscount}
                disabled={discountValue <= 0}
                sx={{ bgcolor: "#2f3891", "&:hover": { bgcolor: "#252e7a" }, "&.Mui-disabled": { bgcolor: "#e2e8f0", color: "#94a3b8" } }}>
                {editingIndex !== null ? "Update" : "Add Discount"}
              </Button>
            </Box>
          </Dialog>

          {openCompany && (
            <NewCompanyPopUp handleCloseDialog={() => setOpenCompany(false)} openModel={openCompany} />
          )}
          {openCustomer && (
            <NewCustomerPopUp handleCloseDialog={() => setOpenCustomer(false)} openModel={openCustomer} onSuccess={handleNewCustomerAdded} />
          )}

          {/* ── Confirm Action Dialog ── */}
          <Dialog open={openD} onClose={() => setOpenD(false)} maxWidth="xs" fullWidth
            PaperProps={{ sx: { borderRadius: 2.5, overflow: "hidden" } }}>
            <Box sx={{ px: 3, py: 2, bgcolor: "#1e293b", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Typography sx={{ fontWeight: 700, fontSize: 16, color: "#ffffff" }}>Confirm Action</Typography>
              <IconButton size="small" onClick={() => setOpenD(false)} sx={{ color: "#94a3b8", "&:hover": { color: "#ffffff", bgcolor: "rgba(255,255,255,0.1)" } }}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            <DialogContent sx={{ pt: 3 }}>
              <DialogContentText>
                Are you sure you want to proceed with invoice success?
              </DialogContentText>
            </DialogContent>
            <Box sx={{ px: 3, py: 2, borderTop: "1px solid #e2e8f0", bgcolor: "#f8fafc", display: "flex", gap: 1.5, justifyContent: "flex-end" }}>
              <Button variant="contained" startIcon={<CheckCircleOutlineSharpIcon />} onClick={handleConfirmDialog}
                sx={{ bgcolor: "#2563eb", "&:hover": { bgcolor: "#1d4ed8" } }}>
                Yes
              </Button>
            </Box>
          </Dialog>
        </Box>

      </form>
    </Box>
  );
};

export default Index;
